import { loadMenu } from './reducers/loadMenu';
import { loading } from './reducers/loading';
import { reset } from './reducers/reset';

export const PlaceStoreContextReadOnly = {};

const PlaceReducer = (state, action) => {
  let newState = state;
  switch (action.type) {
    case 'LOAD_MENU':
      newState = loadMenu(state, action.payload);
      break;
    case 'LOADING':
      newState = loading(state, action.payload);
      break;
    case 'RESET':
      newState = reset(state, action.payload);
      break;

    default:
      newState = state;
      break;
  }

  PlaceStoreContextReadOnly.state = newState;
  return newState;
};

export default PlaceReducer;
